(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/campaign-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/campaign-info.js');

'use strict';

const {
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  ShortDateAndTime: shortDateAndTime
} = svs.utils.date;
const {
  productMapping
} = svs.numbergames;
const {
  AndraChansenRowBanner
} = svs.numbergames.ReactAndraChansenBanners;
const {
  ContainerContext
} = svs.numbergames.fractiongames.contexts;
const CampaignInfo = () => {
  const {
    selectors,
    campaignChances,
    campaignInfo
  } = useContext(ContainerContext);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const productName = productMapping.getProductName(productNumeric);
  if (!campaignChances) {
    return null;
  }
  if (productMapping.isLotto(productNumeric)) {
    return React.createElement(AndraChansenRowBanner, {
      chances: campaignChances
    });
  }
  return React.createElement("div", {
    className: "align-center"
  }, React.createElement("hr", {
    className: "ng-fg-hr margin-top-0 margin-bottom-1"
  }), React.createElement("span", null, productName, " kampanj"), " ", React.createElement("span", {
    className: "f-medium"
  }, campaignInfo.campaignName), React.createElement("br", null), "Kampanjperiod: ", shortDateAndTime(campaignInfo.startDate, true, false), "-", shortDateAndTime(campaignInfo.endDate, true, false), React.createElement("br", null), "Dragning: ", shortDateAndTime(campaignInfo.drawDate, true, false), React.createElement("p", {
    className: "f-medium"
  }, campaignChances, " ", campaignChances > 1 ? 'chanser' : 'chans'));
};
svs.numbergames.fractiongames.components.gamecard.CampaignInfo = CampaignInfo;

 })(window);